import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";

import BuRunAddEdit from "./BURUNAddEdit";
import BURunChargeTable from "./BURunChargeTable";

function BURunTableContainer(props) {
    debugger
  const { path } = useRouteMatch();
    debugger
  return (
    <>
      <Switch>
        <Route path={`${path}/edit/:id`}>
          <BuRunAddEdit />
        </Route>
        <Route path={`${path}/add`}>
          <BuRunAddEdit />
        </Route>
        <Route path={`${path}`}>
          <BURunChargeTable />
          
        </Route>
      </Switch>
    </>
  );
}

export default BURunTableContainer;
